export default function stringToNumber(value: string | number, currentLanguage: string = "pt") {
	if(typeof value === "number")
		return value;
	
	if(currentLanguage === "pt" || currentLanguage === "es")
		return value ? parseFloat(value.replaceAll(".", "").replace(",", ".")) : 0;
	
	return value ? parseFloat(value.replaceAll(",", "")) : 0;
}
